import * as ActionTypes from '../Actions/EnumTypes/ActionEnumTypes';
import {VehicleAction} from '../Actions/Models/VehicleActionModel';
import {Types} from '../../Models/VehicleModel';
import {DEFAULT_PAGE_SIZE, START_FROM} from "../../constants";
import {preparePaginatedList} from "Redux/Actions/VehicleActions";

export type State = Types.VehiclesStore;

export const initialState: State = {
    vehiclesList: [],
    vehiclesPartList: [],
    vehiclesListFiltered: {
        results: [],
        totalCount: null,
        first: null,
        max: null
    },
    searchedVehicles: {
      results: [],
      totalCount: null,
      first: null,
      max: null
    },
    activeVehicleDetails: null,
    singleCarViewData: null,
    choosenCarImages: null,
    error: {},
    success: {},
    queryParams: new URLSearchParams(`?max=${DEFAULT_PAGE_SIZE}&first=${START_FROM}`),
    hasRqError: false,
    hasSearched: false,
    isSearching: false,
    tableSearchFilters: [],
    tableFilters: [],
    shouldResetFilters: false,
    basicQueryParams: { first: START_FROM, max: DEFAULT_PAGE_SIZE }
};

export function carsReducer(state: State = initialState, action: VehicleAction): State {
    switch (action.type) {
        case '@@router/LOCATION_CHANGE' : {
            return {
                ...state,
                vehiclesListFiltered: initialState.vehiclesListFiltered,
                tableFilters: initialState.tableFilters
            }
        }
        case ActionTypes.Vehicle.INITIALIZE_VEHICLES: {
            return {
                ...state,
                vehiclesList: action.payload.vehiclesList
            };
        }
        case ActionTypes.Vehicle.GET_PART_OF_VEHICLES: {
            return {
                ...state,
                vehiclesPartList: action.payload.partList
            };
        }
        case ActionTypes.Vehicle.GET_CARS_NEXT_SUCCESS: {
            const newList = action.payload.vehiclesList;
            newList.results = [...state.vehiclesListFiltered.results, ...newList.results];
            return {
                ...state,
                vehiclesListFiltered: newList
            };
        }
        case ActionTypes.Vehicle.SET_DETAILS_FOR_VEHILE_VIEW: {
            return {
                ...state,
                activeVehicleDetails: action.payload.vehicle
            };
        }
        case ActionTypes.Vehicle.ADD_CAR_SUCCESS: {
            return {
                ...state,
                error: {
                    ...state.error,
                    addCarErr: null
                },
                success: {
                    addCarSuccess: true
                }
            };
        }
        case ActionTypes.Vehicle.ADD_CAR_FAILURE: {
            return {
                ...state,
                error: {
                    ...state.error,
                    addCarErr: action.payload.error
                },
                success: {
                    ...state.success,
                    addCarSuccess: false
                }
            };
        }
        case ActionTypes.Vehicle.GET_SINGLE_CAR_DETAILS_SUCCESS: {
            if (action.payload.singleCarViewData === null) {
                return {
                    ...state,
                    singleCarViewData: action.payload.singleCarViewData,
                    activeVehicleDetails: null
                };
            } else {
                const {id} = action.payload.singleCarViewData.car;
                const vehicles = [...state.vehiclesList];
                const vehiclesv2 = [...state.vehiclesListFiltered.results];
                const foundidx = vehicles.findIndex(e => e.id === id);
                const foundidxFiltered = vehiclesv2.findIndex(e => e.id === id);
                if (foundidx !== -1) {
                    vehicles[foundidx] = action.payload.singleCarViewData.car;
                }
                if (foundidxFiltered !== -1) {
                    vehiclesv2[foundidxFiltered] = action.payload.singleCarViewData.car;
                }

                return {
                    ...state,
                    singleCarViewData: action.payload.singleCarViewData,
                    vehiclesList: vehicles,
                    vehiclesListFiltered: {
                        ...state.vehiclesListFiltered,
                        results: vehiclesv2
                    },
                    activeVehicleDetails: action.payload.singleCarViewData.car
                };
            }
        }
        case ActionTypes.Vehicle.GET_SINGLE_CAR_ADDITIONAL_INFO: {
            const {singleCarViewData} = state;
            return {
                ...state,
                singleCarViewData: {
                    ...singleCarViewData,
                    ...action.payload.singleCarViewData
                }
            }
        }
        case ActionTypes.Vehicle.GET_SINGLE_CAR_IMAGES_SUCCESS: {
            return {
                ...state,
                choosenCarImages: action.payload.images
            };
        }
        case ActionTypes.Vehicle.GET_FILTERED_CARS_SUCCESS: {
            return {
                ...state,
                vehiclesListFiltered: action.payload.vehiclesListFiltered
            };
        }
        case ActionTypes.Vehicle.RESET_CAR_FILTERED_DATA: {
            return {
                ...state,
                vehiclesListFiltered: initialState.vehiclesListFiltered
            };
        }
        // case ActionTypes.Vehicle.GET_TOTAL_LIST_CARS_SUCCESS: {
        //     return {
        //         ...state,
        //         vehiclesList: action.payload.vehiclesTotalList
        //     };
        // }
        case ActionTypes.Vehicle.UPDATE_CAR_LATEST_DATAFRAME: {
            const vehicles = [...state.vehiclesList];
            const vehiclesv2 = [...state.vehiclesListFiltered.results];
            const foundidx = vehicles.findIndex(e => e.id === action.payload.carId);
            const foundidxFiltered = vehiclesv2.findIndex(e => e.id === action.payload.carId);
            if (foundidx !== -1) {
                vehicles[foundidx].latestDataframe = action.payload.dataframe;
            }
            if (foundidxFiltered !== -1) {
                vehiclesv2[foundidxFiltered].latestDataframe = action.payload.dataframe;
            }
            return {
                ...state,
                singleCarViewData: {
                    ...state.singleCarViewData,
                    car: {
                        ...state.singleCarViewData.car,
                        latestDataframe: action.payload.dataframe
                    }
                },
                vehiclesList: vehicles,
                vehiclesListFiltered: {
                    ...state.vehiclesListFiltered,
                    results: vehiclesv2
                }
            };
        }
        case ActionTypes.Vehicle.SET_TURN_OFF_CAR_DATE: {
            const vehicleDetails = state.activeVehicleDetails;
            const vehicles = [...state.vehiclesListFiltered.results];
            const foundId = vehicles.findIndex(e => e.id === vehicleDetails.id);
            if (foundId !== -1) {
                vehicles[foundId].turnOffDate = action.payload.turnOffData.turnOffDate;
            }
            return {
                ...state,
                activeVehicleDetails: {
                    ...vehicleDetails,
                    ...action.payload.turnOffData
                    // turnOffDate: action.payload.turnOffData.turnOffDate
                },
                vehiclesListFiltered: {
                    ...state.vehiclesListFiltered,
                    results: vehicles
                },
            };
            // const singleCarData = state.singleCarViewData;
            // singleCarData.car.turnOffDate = action.payload.turnOffDate;
            // return {
            //     ...state,
            //     singleCarViewData: singleCarData
            // };
        }
      case ActionTypes.Vehicle.SAVE_SEARCH_QUERY: {
        return {
          ...state,
          queryParams: action.payload.queryParams
        }
      }
      case ActionTypes.Vehicle.UPDATE_REQUEST_HAS_ERROR: {
        return {
          ...state,
          hasRqError: action.payload.hasRqError
        }
      }
      case ActionTypes.Vehicle.CLEAR_SEARCH_META: {
        return {
          ...state,
          hasRqError: false,
          hasSearched: false,
          queryParams: null
        }
      }
      case ActionTypes.Vehicle.UPDATE_HAS_SEARCHED: {
        return {
          ...state,
          hasSearched: action.payload.hasSearched,
        }
      }
      case ActionTypes.Vehicle.CACHE_SEARCHED_VEHICLES: {
        return {
          ...state,
          searchedVehicles: action.payload.searchedVehicles,
        }
      }
      case ActionTypes.Vehicle.RESTORE_FILTERED_SEARCHED_VEHICLES:
      case ActionTypes.Vehicle.INIT_SEARCHED_VEHICLES: {
        return {
          ...state,
          vehiclesListFiltered: state.searchedVehicles
        }
      }
      case ActionTypes.Vehicle.RESTORE_FILTERED_VEHICLES: {
        return {
          ...state,
          vehiclesListFiltered: {
            ...state.vehiclesListFiltered,
            results: [...state.vehiclesList]
          }
        }
      }
      case ActionTypes.Vehicle.SET_IS_SEARCHING: {
        return {
          ...state,
          isSearching: action.payload.isSearching
        }
      }
      case ActionTypes.Vehicle.SAVE_SEARCHED_FILTERS: {
        return {
          ...state,
          tableSearchFilters: action.payload.filters
        }
      }
      case ActionTypes.Vehicle.SAVE_FILTERS: {
        return {
          ...state,
          tableFilters: action.payload.filters
        }
      }
      case ActionTypes.Vehicle.RESET_INIT:
      case ActionTypes.Vehicle.RESET_SUCCEED: {
        return {
          ...state,
          shouldResetFilters: !state.shouldResetFilters
        }
      }
      case ActionTypes.Vehicle.SET_BASIC_QUERY_PARAMS: {
        return {
          ...state,
          basicQueryParams: action.payload.basicQueryParams
        }
      }
        default: {
            return {
                ...state
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Reducers/VehiclesReducer.ts